import { EigenleistungAufstellung, SelectOption } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_EIGENLEISTUNG_TABLE = 'EIGENLEISTUNG_TABLE';

export interface EigenleistungTableModelConfig extends DynamicFormValueControlModelConfig<EigenleistungAufstellung> {
  gewerke?: SelectOption[];
}

export class EigenleistungTableModel extends DynamicFormValueControlModel<EigenleistungAufstellung> {
  @serializable() readonly type: string = TYPE_EIGENLEISTUNG_TABLE;
  @serializable() gewerke: SelectOption[];

  constructor(config: EigenleistungTableModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    this.gewerke = config.gewerke || [];
  }
}
